import { useEffect, useState, useCallback } from "react";
import axios from '../../../api/apiClient';
import { token, domain } from "../../Security";

import UpdateIcon from "@mui/icons-material/Update";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import EditIcon from "@mui/icons-material/Edit";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import { CreateTableTransaction } from "./Tables";
import { Button, CreateTableNew, GeneralMessage, useGeneralMessage } from "../../../common/APICommon";
import { LoadingSpinner } from "../../../common/Loading";
import { ViewImage } from "../forms/ViewImage";
import { ClearGeneralForm } from "../forms/ClearGeneralForm";
import { ViewOTForm } from "../forms/ViewOTForm";
import { ViewLeaveForm } from "../forms/ViewLeaveForm";
import { ViewChangeScheduleForm } from "../forms/ViewChangeScheduleForm";
import { ViewChangeLogRequestForm } from "../forms/ViewChangeLogRequestForm";
import { ViewOffsetForm } from "../forms/ViewOffsetForm";
import { EditOTForm } from "../forms/EditOTForm";
import { EditLeaveForm } from "../forms/EditLeaveForm";
import { EditChangeScheduleForm } from "../forms/EditChangeScheduleForm";
import { EditChangeLogRequestForm } from "../forms/EditChangeLogRequestForm";
import { EditOffsetForm } from "../forms/EditOffsetForm";
import { ViewSalaryAdvanceModal } from "./ViewSalaryAdvanceModal";
import { EditSalaryAdvanceModal } from "./EditSalaryAdvanceModal";
import { StatusBadge } from "../../../common/Badge";
import { SALARYADVANCETATUS } from "../../../utils/enums";

export const Transactions = ({ user, filteredEmployee }) => {
  var header = [
    "Reference No.",
    // "Uploaded Image",
    "Date",
    "Date From",
    "Date To",
    "Request Date",
    "Request",
    // "Type",
    "Track Approvers",
    "Status",
    "",
  ];
  var accessor = [
    "id",
    // "content",
    "date",
    "dateFrom",
    "dateTo",
    "requestDate",
    "requestTypeDescription",
    // "type",
    "trackApprovers",
    "status",
    "manage",
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [filterData, setFilterData] = useState([]);
  const [transactions, setTransactions] = useState([]);

  const [overtimeRequestData, setOvertimeRequestData] = useState([]);
  const [leaveRequestData, setLeaveRequestData] = useState([]);
  const [changeOfScheduleData, setChangeOfScheduleData] = useState([]);
  const [changeLogRequestData, setChangeLogRequestData] = useState([]);
  const [requestType, setRequestType] = useState("");

  const [viewImageData, setViewImageData] = useState("");
  const [showViewImage, setShowViewImage] = useState(false);

  //OT
  const [showViewOTForm, setShowViewOTForm] = useState(false);
  const [
    employeePersonalInformationFullName,
    setEmployeePersonalInformationFullName,
  ] = useState("");
  const [employeePersonalInformationId, setEmployeePersonalInformationId] =
    useState("");
  const [overtimeType, setOvertimeType] = useState("");
  const [date, setDate] = useState("");
  const [hours, setHours] = useState("");
  const [hasOvertimeAllowance, setHasOvertimeAllowance] = useState(false);
  const [isAboveTwoHoursOvertime, setIsAboveTwoHoursOvertime] = useState(false);
  const [reason, setReason] = useState("");
  const [filesOT, setFilesOT] = useState("");
  //Leave
  const [showViewLeaveForm, setShowViewLeaveForm] = useState(false);
  const [
    employeePersonalInformationFullNameLeave,
    setEmployeePersonalInformationFullNameLeave,
  ] = useState("");
  const [leaveType, setLeaveType] = useState("");
  const [dateFromLeave, setDateFromLeave] = useState("");
  const [dateToLeave, setDateToLeave] = useState("");
  const [daysLeave, setDaysLeave] = useState("");
  const [isHalfDayLeave, setIsHalfDayLeave] = useState(false);
  const [reasonLeave, setReasonLeave] = useState("");
  const [filesLeave, setFilesLeave] = useState("");
  //Change Request
  const [showViewChangeScheduleForm, setShowViewChangeScheduleForm] =
    useState(false);
  const [
    employeePersonalInformationFullNameChangeSchedule,
    setEmployeePersonalInformationFullNameChangeSchedule,
  ] = useState("");
  const [dateFromChangeSchedule, setDateFromChangeSchedule] = useState("");
  const [dateToChangeSchedule, setDateToChangeSchedule] = useState("");
  const [shiftScheduleFromId, setShiftScheduleFromId] = useState("");
  const [shiftScheduleToId, setShiftScheduleToId] = useState("");
  const [reasonChangeSchedule, setReasonChangeSchedule] = useState("");
  const [filesChangeSchedule, setFilesChangeSchedule] = useState("");
  //DTR CORRECTION
  const [showViewChangeLogRequestForm, setShowViewChangeLogRequestForm] =
    useState(false);
  const [
    employeePersonalInformationIdChangeLogRequest,
    setEmployeePersonalInformationIdChangeLogRequest,
  ] = useState("");
  const [
    employeePersonalInformationFullNameChangeLogRequest,
    setEmployeePersonalInformationFullNameChangeLogRequest,
  ] = useState("");
  const [timeTypeChangeLogRequest, setTimeTypeChangeLogRequest] = useState("");
  const [dateChangeLogRequest, setDateChangeLogRequest] = useState("");
  const [timeRequestedChangeLogRequest, setTimeRequestedChangeLogRequest] =
    useState("");
  const [statusChangeLogRequest, setStatusChangeLogRequest] = useState("");
  const [reasonChangeLogRequest, setReasonChangeLogRequest] = useState("");
  const [
    reasonForRejectionChangeLogRequest,
    setReasonForRejectionChangeLogRequest,
  ] = useState("");

  // ADDED - Tab state for separating request types
  const [activeTab, setActiveTab] = useState("workflow"); // "workflow" or "financial"
  const [salaryAdvanceRequests, setSalaryAdvanceRequests] = useState([]);
  const [loadingSalaryAdvance, setLoadingSalaryAdvance] = useState(false);
  const [selectedSalaryAdvance, setSelectedSalaryAdvance] = useState(null);
  const [showSalaryAdvanceModal, setShowSalaryAdvanceModal] = useState(false);
  const [showEditSalaryAdvanceModal, setShowEditSalaryAdvanceModal] = useState(false);
  const [selectedEditSalaryAdvance, setSelectedEditSalaryAdvance] = useState(null);

  const [filesChangeLog, setFilesChangeLog] = useState("");
  const [selectedItinerary, setSelectedItinerary] = useState([]);
  const [itineraryTimeIn, setItineraryTimeIn] = useState("");
  const [itineraryTimeOut, setItineraryTimeOut] = useState("");
  const [itineraryLocation, setItineraryLocation] = useState("");
  const [isItinerayAddState, setIsItinerayAddState] = useState(false);
  const [isItinerayUpdateState, setIsItinerayUpdateState] = useState(false);
  const [isItinerayDeleteState, setIsItinerayDeleteState] = useState(false);

  const [daysRange, setDaysRange] = useState(15);
  const [daysRangeTemp, setDaysRangeTemp] = useState(15);

  const updateDaysRange = () => {
    if (daysRange !== daysRangeTemp) {
      setDaysRange(daysRangeTemp);
    }
  };

  //Offset
  const [showViewOffsetForm, setShowViewOffsetForm] = useState(false);
  const [
    employeePersonalInformationFullNameOffset,
    setEmployeePersonalInformationFullNameOffset,
  ] = useState("");
  const [
    employeePersonalInformationIdOffset,
    setEmployeePersonalInformationIdOffset,
  ] = useState("");
  const [offset_type, setOffset_type] = useState("");
  const [offset_type_current, setOffset_type_current] = useState("");
  const [offset_referenceDate, setOffset_referenceDate] = useState("");
  const [offset_date, setOffset_date] = useState("");
  const [offset_hours, setOffset_hours] = useState(0);
  const [offset_referenceId, setOffset_referenceId] = useState("");
  const [offset_dateFrom, setOffset_dateFrom] = useState("");
  const [offset_dateTo, setOffset_dateTo] = useState("");
  const [offset_days, setOffset_days] = useState(0);
  const [offset_reason, setOffset_reason] = useState("");
  const [filesOffset, setFilesOffset] = useState("");

  useEffect(() => {
    if (offset_type !== offset_type_current) {
      setOffset_type_current(offset_type)

      setOffset_referenceDate("");
      setOffset_date("");
      setOffset_hours("");
      setOffset_referenceId("");
      setOffset_dateFrom("");
      setOffset_dateTo("");
      setOffset_days("");
    }
  }, [offset_type, offset_type_current])

  const resetOffsetVariables = () => {
    setOffset_type("");
    setOffset_referenceDate("");
    setOffset_date("");
    setOffset_hours("");
    setOffset_referenceId("");
    setOffset_dateFrom("");
    setOffset_dateTo("");
    setOffset_days("");
    setOffset_reason("");
    setFilesOffset("");
  };

  const [deleteData, setDeleteData] = useState([]);
  const [showDeleteForm, setShowDeleteForm] = useState(false);

  const [editData, setEditData] = useState([]);
  const [showEditOTForm, setShowEditOTForm] = useState(false);
  const [showEditOffsetForm, setShowEditOffsetForm] = useState(false);
  const [showEditLeaveForm, setShowEditLeaveForm] = useState(false);
  const [showEditChangeOfScheduleForm, setShowEditChangeOfScheduleForm] =
    useState(false);
  const [showEditChangeLogForm, setShowEditChangeLogForm] = useState(false);


  const overTimeApiUrl = domain + "/api/OvertimeRequest";
  const leaveTimeApiUrl = domain + "/api/LeaveRequest";
  const changeOfScheduleTimeApiUrl = domain + "/api/ChangeScheduleRequest";
  const changeLogRequestTimeApiUrl = domain + "/api/ChangeLogRequest";
  const offsetRequestTimeApiUrl = domain + "/api/OffsetRequest";

  // --- REFACTORED: Initialize useGeneralMessage Hook ---
  // Default duration set to 5000ms to match your original timeout
  const {
    showMessage,
    message: apiMessage,
    isSuccess: apiIsSuccess,
    showGeneralMessage
  } = useGeneralMessage(5000);

  const [approverData, setApproverData] = useState(null);
  const fetchDataApproverData = useCallback(async () => {
    const apiUrl = domain + "/api/ApproverHierarchy";

    try {
      const response = await axios.get(
        `${apiUrl}/${user.employeePersonalInformationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        }
      );
      return response.data; // Set the response data to the state
    } catch (error) {
      console.error("Error fetching data:", error);
      return null;
    }
  }, [user]);
  const fetchDataLocationApproverData = useCallback(async () => {
    const apiUrl = domain + "/api/LocationApproverHierarchy";

    try {
      const response = await axios.get(
        `${apiUrl}/employeePersonalInformationId/${user.employeePersonalInformationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        }
      );
      return response.data; // Set the response data to the state
    } catch (error) {
      console.error("Error fetching data:", error);
      return null;
    }
  }, [user]);

  const generatePrimaryApprover = () => {
    return (
      <>
        {approverData?.primaryApprover?.primaryApprover1Id && (
          <span style={{ margin: "0 10px" }}>
            {approverData?.primaryApprover?.primaryApprover1FullName}
          </span>
        )}
        {approverData?.primaryApprover?.primaryApprover2Id && (
          <span style={{ margin: "0 10px" }}>
            {approverData?.primaryApprover?.primaryApprover2FullName}
          </span>
        )}
        {approverData?.primaryApprover?.primaryApprover3Id && (
          <span style={{ margin: "0 10px" }}>
            {approverData?.primaryApprover?.primaryApprover3FullName}
          </span>
        )}
        {approverData?.primaryApprover?.primaryApprover4Id && (
          <span style={{ margin: "0 10px" }}>
            {approverData?.primaryApprover?.primaryApprover4FullName}
          </span>
        )}
      </>
    );
  };
  const generateSecondaryApprover = () => {
    return (
      <>
        {approverData?.secondaryApprover?.secondaryApprover1Id && (
          <span style={{ margin: "0 10px" }}>
            {approverData?.secondaryApprover?.secondaryApprover1FullName}
          </span>
        )}
        {approverData?.secondaryApprover?.secondaryApprover2Id && (
          <span style={{ margin: "0 10px" }}>
            {approverData?.secondaryApprover?.secondaryApprover2FullName}
          </span>
        )}
        {approverData?.secondaryApprover?.secondaryApprover3Id && (
          <span style={{ margin: "0 10px" }}>
            {approverData?.secondaryApprover?.secondaryApprover3FullName}
          </span>
        )}
        {approverData?.secondaryApprover?.secondaryApprover4Id && (
          <span style={{ margin: "0 10px" }}>
            {approverData?.secondaryApprover?.secondaryApprover4FullName}
          </span>
        )}
      </>
    );
  };
  const generateTertiaryApprover = () => {
    return (
      <>
        {approverData?.tertiaryApprover?.tertiaryApprover1Id && (
          <span style={{ margin: "0 10px" }}>
            {approverData?.tertiaryApprover?.tertiaryApprover1FullName}
          </span>
        )}
        {approverData?.tertiaryApprover?.tertiaryApprover2Id && (
          <span style={{ margin: "0 10px" }}>
            {approverData?.tertiaryApprover?.tertiaryApprover2FullName}
          </span>
        )}
        {approverData?.tertiaryApprover?.tertiaryApprover3Id && (
          <span style={{ margin: "0 10px" }}>
            {approverData?.tertiaryApprover?.tertiaryApprover3FullName}
          </span>
        )}
        {approverData?.tertiaryApprover?.tertiaryApprover4Id && (
          <span style={{ margin: "0 10px" }}>
            {approverData?.tertiaryApprover?.tertiaryApprover4FullName}
          </span>
        )}
      </>
    );
  };

  const fetchDataApproverById = useCallback(async (data) => {
    const apiUrlApproverHierarchy = domain + "/api/ApproverHierarchy";

    try {
      const response = await axios.get(
        apiUrlApproverHierarchy + `/${data.employeePersonalInformationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        }
      );

      return response.data; // Return the response data
    } catch (error) {
      console.error("Error fetching data:", error);
      return []; // Return an empty array in case of error
    }
  }, []);

  const fetchData = useCallback(async () => {
    setLoading(true);
    if (!filteredEmployee) {
      return;
    }

    try {

      const apiUrl = domain + "/api/TransactionRequest";

      const response = await axios.get(
        apiUrl +
        `/my-requests/${daysRange}/${user.employeePersonalInformationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        }
      );

      const approverData = await fetchDataApproverById(user);
      const requests = response.data;

      let hasPrimary = false;
      let hasSecondary = false;
      let hasTertiary = false;

      if (approverData.primaryApprover) {
        if (
          approverData.primaryApprover.primaryApprover1Id ||
          approverData.primaryApprover.primaryApprover2Id ||
          approverData.primaryApprover.primaryApprover3Id ||
          approverData.primaryApprover.primaryApprover4Id
        ) {
          hasPrimary = true;
        }
      }

      if (approverData.secondaryApprover) {
        if (
          approverData.secondaryApprover.secondaryApprover1Id ||
          approverData.secondaryApprover.secondaryApprover2Id ||
          approverData.secondaryApprover.secondaryApprover3Id ||
          approverData.secondaryApprover.secondaryApprover4Id
        ) {
          hasSecondary = true;
        }
      }

      if (approverData.tertiaryApprover) {
        if (
          approverData.tertiaryApprover.tertiaryApprover1Id ||
          approverData.tertiaryApprover.tertiaryApprover2Id ||
          approverData.tertiaryApprover.tertiaryApprover3Id ||
          approverData.tertiaryApprover.tertiaryApprover4Id
        ) {
          hasTertiary = true;
        }
      }

      for (let index = 0; index < requests.length; index++) {
        if (requests[index].approval) {
          if (!hasPrimary) {
            delete requests[index].approval.primaryApproverId;
            delete requests[index].approval.primaryApproverFullName;
            delete requests[index].approval.primaryApproverUpdateDate;
            delete requests[index].approval.primaryApproverStatus;
          }

          if (!hasSecondary) {
            delete requests[index].approval.secondaryApproverId;
            delete requests[index].approval.secondaryApproverFullName;
            delete requests[index].approval.secondaryApproverUpdateDate;
            delete requests[index].approval.secondaryApproverStatus;
          }

          if (!hasTertiary) {
            delete requests[index].approval.tertiaryApproverId;
            delete requests[index].approval.tertiaryApproverFullName;
            delete requests[index].approval.tertiaryApproverUpdateDate;
            delete requests[index].approval.tertiaryApproverStatus;
          }
        } else {
          requests[index].approval = {
            primaryApproverId: 0,
            primaryApproverFullName: "",
            primaryApproverUpdateDate: "",
            primaryApproverStatus: "",
            secondaryApproverId: 0,
            secondaryApproverFullName: "",
            secondaryApproverUpdateDate: "",
            secondaryApproverStatus: "",
            tertiaryApproverId: 0,
            tertiaryApproverFullName: "",
            tertiaryApproverUpdateDate: "",
            tertiaryApproverStatus: "",
          };

          if (!hasPrimary) {
            delete requests[index].approval.primaryApproverId;
            delete requests[index].approval.primaryApproverFullName;
            delete requests[index].approval.primaryApproverUpdateDate;
            delete requests[index].approval.primaryApproverStatus;
          }

          if (!hasSecondary) {
            delete requests[index].approval.secondaryApproverId;
            delete requests[index].approval.secondaryApproverFullName;
            delete requests[index].approval.secondaryApproverUpdateDate;
            delete requests[index].approval.secondaryApproverStatus;
          }

          if (!hasTertiary) {
            delete requests[index].approval.tertiaryApproverId;
            delete requests[index].approval.tertiaryApproverFullName;
            delete requests[index].approval.tertiaryApproverUpdateDate;
            delete requests[index].approval.tertiaryApproverStatus;
          }
        }
      }

      let _approverData = await fetchDataApproverData();

      const { primaryApprover, secondaryApprover, tertiaryApprover } =
        _approverData;

      const isPrimaryNull =
        !primaryApprover ||
        (primaryApprover.primaryApprover1Id === null &&
          primaryApprover.primaryApprover2Id === null &&
          primaryApprover.primaryApprover3Id === null &&
          primaryApprover.primaryApprover4Id === null);

      const isSecondaryNull =
        !secondaryApprover ||
        (secondaryApprover.secondaryApprover1Id === null &&
          secondaryApprover.secondaryApprover2Id === null &&
          secondaryApprover.secondaryApprover3Id === null &&
          secondaryApprover.secondaryApprover4Id === null);

      const isTertiaryNull =
        !tertiaryApprover ||
        (tertiaryApprover.tertiaryApprover1Id === null &&
          tertiaryApprover.tertiaryApprover2Id === null &&
          tertiaryApprover.tertiaryApprover3Id === null &&
          tertiaryApprover.tertiaryApprover4Id === null);

      if (isPrimaryNull && isSecondaryNull && isTertiaryNull) {
        const oldData = _approverData;
        const foundData = await fetchDataLocationApproverData();

        console.log("foundData", foundData);

        const newData = {
          employeeId: oldData.employeeId,
          employeePersonalInformationFullName:
            oldData.employeePersonalInformationFullName,
          employeePersonalInformationId: oldData.employeePersonalInformationId,
          primaryApprover: {
            primaryApprover1FullName:
              foundData?.primaryApprovers[0]?.approverFullName ?? null,
            primaryApprover1Id:
              foundData?.primaryApprovers[0]?.approverId ?? null,
            primaryApprover2FullName:
              foundData?.primaryApprovers[1]?.approverFullName ?? null,
            primaryApprover2Id:
              foundData?.primaryApprovers[1]?.approverId ?? null,
            primaryApprover3FullName:
              foundData?.primaryApprovers[2]?.approverFullName ?? null,
            primaryApprover3Id:
              foundData?.primaryApprovers[2]?.approverId ?? null,
            primaryApprover4FullName:
              foundData?.primaryApprovers[3]?.approverFullName,
            primaryApprover4Id:
              foundData?.primaryApprovers[3]?.approverId ?? null,
          },
          secondaryApprover: {
            secondaryApprover1FullName:
              foundData?.secondaryApprovers[0]?.approverFullName ?? null,
            secondaryApprover1Id:
              foundData?.secondaryApprovers[0]?.approverId ?? null,
            secondaryApprover2FullName:
              foundData?.secondaryApprovers[1]?.approverFullName ?? null,
            secondaryApprover2Id:
              foundData?.secondaryApprovers[1]?.approverId ?? null,
            secondaryApprover3FullName:
              foundData?.secondaryApprovers[2]?.approverFullName ?? null,
            secondaryApprover3Id:
              foundData?.secondaryApprovers[2]?.approverId ?? null,
            secondaryApprover4FullName:
              foundData?.secondaryApprovers[3]?.approverFullName,
            secondaryApprover4Id:
              foundData?.secondaryApprovers[3]?.approverId ?? null,
          },
          tertiaryApprover: {
            tertiaryApprover1FullName:
              foundData?.tertiaryApprovers[0]?.approverFullName ?? null,
            tertiaryApprover1Id:
              foundData?.tertiaryApprovers[0]?.approverId ?? null,
            tertiaryApprover2FullName:
              foundData?.tertiaryApprovers[1]?.approverFullName ?? null,
            tertiaryApprover2Id:
              foundData?.tertiaryApprovers[1]?.approverId ?? null,
            tertiaryApprover3FullName:
              foundData?.tertiaryApprovers[2]?.approverFullName ?? null,
            tertiaryApprover3Id:
              foundData?.tertiaryApprovers[2]?.approverId ?? null,
            tertiaryApprover4FullName:
              foundData?.tertiaryApprovers[3]?.approverFullName,
            tertiaryApprover4Id:
              foundData?.tertiaryApprovers[3]?.approverId ?? null,
          },
        };

        _approverData = newData;
      }

      setApproverData(_approverData);

      setTransactions(requests); // Set the response data to the state
      setFilterData(requests); // Set the response data to the state
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Set loading state to false after data fetching is complete
    }
  }, [
    daysRange,
    filteredEmployee,
    user,
    fetchDataApproverById,
    fetchDataApproverData,
    fetchDataLocationApproverData,
  ]);
  const fetchSalaryAdvanceRequests = useCallback(async () => {
    if (!filteredEmployee) return;

    setLoadingSalaryAdvance(true);
    try {
      const salaryAdvanceApiUrl = domain + "/api/TransactionRequest/my-requests/new";

      const response = await axios.get(
        `${salaryAdvanceApiUrl}/${daysRange}/${user.employeePersonalInformationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Salary Advance Requests from API:", response.data);
      setSalaryAdvanceRequests(response.data);
    } catch (error) {
      console.error("Error fetching salary advance requests:", error);
      showGeneralMessage("Failed to load salary advance requests", false);
    } finally {
      setLoadingSalaryAdvance(false);
    }
  }, [daysRange, user, filteredEmployee]);

  const fetchOTRequestData = useCallback(async () => { }, []);
  const fetchLeaveRequestData = useCallback(async () => { }, []);
  const fetchChangeOfScheduleRequestData = useCallback(async () => { }, []);
  const fetchChangeLogRequestData = useCallback(async () => { }, []);

  useEffect(() => {
    fetchData();
    fetchOTRequestData();
    fetchLeaveRequestData();
    fetchChangeOfScheduleRequestData();
    fetchChangeLogRequestData();
    fetchSalaryAdvanceRequests();
  }, [
    fetchData,
    fetchOTRequestData,
    fetchLeaveRequestData,
    fetchChangeOfScheduleRequestData,
    fetchChangeLogRequestData,
    fetchSalaryAdvanceRequests,
  ]);

  const handleFilter = (value) => {
    setCurrentPage(1);
    const res = filterData.filter((f) => f.id.toString().startsWith(value));

    setTransactions(res);
  };

  const fetchOTRequest = useCallback(
    async (data) => {
      setLoadingRequest(true);
      try {
        const response = await axios.get(overTimeApiUrl + `/${data.id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        });
        return response.data; // Set the response data to the state
      } catch (error) {
        setLoadingRequest(false);
        console.error("Error fetching data:", error);
        return [];
      } finally {
        setLoadingRequest(false);
      }
    },
    [overTimeApiUrl]
  );
  const fetchLeaveRequest = useCallback(
    async (data) => {
      setLoadingRequest(true);
      try {
        const response = await axios.get(leaveTimeApiUrl + `/${data.id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        });
        return response.data; // Set the response data to the state
      } catch (error) {
        setLoadingRequest(false);
        console.error("Error fetching data:", error);
        return [];
      } finally {
        setLoadingRequest(false);
      }
    },
    [leaveTimeApiUrl]
  );
  const fetchChangeOfScheduleRequest = useCallback(
    async (data) => {
      setLoadingRequest(true);
      try {
        const response = await axios.get(
          changeOfScheduleTimeApiUrl + `/${data.id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json", // You can include other headers if needed
            },
          }
        );
        return response.data; // Set the response data to the state
      } catch (error) {
        setLoadingRequest(false);
        console.error("Error fetching data:", error);
        return [];
      } finally {
        setLoadingRequest(false);
      }
    },
    [changeOfScheduleTimeApiUrl]
  );
  const fetchChangeLogRequest = useCallback(
    async (data) => {
      setLoadingRequest(true);
      try {
        const response = await axios.get(
          changeLogRequestTimeApiUrl + `/${data.id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json", // You can include other headers if needed
            },
          }
        );
        return response.data; // Set the response data to the state
      } catch (error) {
        setLoadingRequest(false);
        console.error("Error fetching data:", error);
        return [];
      } finally {
        setLoadingRequest(false);
      }
    },
    [changeLogRequestTimeApiUrl]
  );
  const fetchOffsetRequest = useCallback(
    async (data) => {
      setLoadingRequest(true);
      try {
        const response = await axios.get(
          offsetRequestTimeApiUrl + `/${data.id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json", // You can include other headers if needed
            },
          }
        );
        return response.data; // Set the response data to the state
      } catch (error) {
        setLoadingRequest(false);
        console.error("Error fetching data:", error);
        return [];
      } finally {
        setLoadingRequest(false);
      }
    },
    [offsetRequestTimeApiUrl]
  );

  const viewHandleClick = async (data) => {
    setRequestType(data.requestTypeDescription);

    if (data.requestTypeDescription === "Overtime Request") {
      setShowViewOTForm(true);
      const requestDataWithId = await fetchOTRequest(data);
      setEmployeePersonalInformationFullName(
        requestDataWithId.employeePersonalInformationFullName
      );
      setEmployeePersonalInformationId(
        requestDataWithId.employeePersonalInformationId
      );
      setOvertimeType(requestDataWithId.overtimeType);
      setDate(requestDataWithId.date);
      setHours(requestDataWithId.hours);
      setHasOvertimeAllowance(requestDataWithId.hasOvertimeAllowance);
      setIsAboveTwoHoursOvertime(requestDataWithId.isAboveTwoHoursOvertime);
      setReason(requestDataWithId.reason);
      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesOT(filesToBeSet);
    }

    if (data.requestTypeDescription === "Leave Request") {
      setShowViewLeaveForm(true);
      const requestDataWithId = await fetchLeaveRequest(data);
      setEmployeePersonalInformationFullNameLeave(
        requestDataWithId.employeePersonalInformationFullName
      );
      setLeaveType(requestDataWithId.leaveTypeId);
      setDateFromLeave(requestDataWithId.dateFrom);
      setDateToLeave(requestDataWithId.dateTo);
      setDaysLeave(requestDataWithId.days);
      setIsHalfDayLeave(requestDataWithId.isHalfDay);
      setReasonLeave(requestDataWithId.reason);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesLeave(filesToBeSet);
    }

    if (data.requestTypeDescription === "Change Schedule") {
      setShowViewChangeScheduleForm(true);
      const requestDataWithId = await fetchChangeOfScheduleRequest(data);
      setEmployeePersonalInformationFullNameChangeSchedule(
        requestDataWithId.employeePersonalInformationFullName
      );
      setDateFromChangeSchedule(requestDataWithId.dateFrom);
      setDateToChangeSchedule(requestDataWithId.dateTo);
      setShiftScheduleFromId(requestDataWithId.shiftScheduleFromId);
      setShiftScheduleToId(requestDataWithId.shiftScheduleToId);
      setReasonChangeSchedule(requestDataWithId.reason);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesChangeSchedule(filesToBeSet);
    }

    if (data.requestTypeDescription === "Change Log Request") {
      setShowViewChangeLogRequestForm(true);
      const requestDataWithId = await fetchChangeLogRequest(data);
      setEmployeePersonalInformationIdChangeLogRequest(
        requestDataWithId.employeePersonalInformationId
      );
      setEmployeePersonalInformationFullNameChangeLogRequest(
        requestDataWithId.employeePersonalInformationFullName
      );
      setTimeTypeChangeLogRequest(requestDataWithId.timeType);
      setDateChangeLogRequest(requestDataWithId.date);
      setTimeRequestedChangeLogRequest(requestDataWithId.timeRendered);
      setReasonChangeLogRequest(requestDataWithId.reason);
      setReasonForRejectionChangeLogRequest(
        requestDataWithId.reasonForRejection
      );
      setSelectedItinerary(requestDataWithId.changeLogItineraries);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesChangeLog(filesToBeSet);
    }

    if (data.requestTypeDescription === "Offset") {
      setShowViewOffsetForm(true);
      const requestDataWithId = await fetchOffsetRequest(data);
      setEmployeePersonalInformationFullNameOffset(
        requestDataWithId.employeePersonalInformationFullName
      );
      setEmployeePersonalInformationIdOffset(
        requestDataWithId.employeePersonalInformationId
      );
      setOffset_type(requestDataWithId.type);
      setOffset_type_current(requestDataWithId.type);
      setOffset_referenceDate(requestDataWithId.referenceDate);
      setOffset_date(requestDataWithId.date);
      setOffset_hours(requestDataWithId.hours);
      setOffset_referenceId(requestDataWithId.referenceId);
      setOffset_dateFrom(requestDataWithId.dateFrom);
      setOffset_dateTo(requestDataWithId.dateTo);
      setOffset_days(requestDataWithId.days);
      setOffset_reason(requestDataWithId.reason);
      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesOffset(filesToBeSet);
    }
  };
  const closeViewHandleClick = () => {
    if (requestType === "Overtime Request") {
      setShowViewOTForm(false);
    }

    if (requestType === "Leave Request") {
      setShowViewLeaveForm(false);
    }

    if (requestType === "Change Schedule") {
      setShowViewChangeScheduleForm(false);
    }

    if (requestType === "Change Log Request") {
      setShowViewChangeLogRequestForm(false);
    }

    if (requestType === "Offset") {
      setShowViewOffsetForm(false);
    }
  };

  const viewSalaryAdvanceHandleClick = (data) => {
    console.log("View clicked with data:", data);
    setSelectedSalaryAdvance(data);
    setShowSalaryAdvanceModal(true);
  };

  const closeSalaryAdvanceModal = () => {
    setShowSalaryAdvanceModal(false);
    setSelectedSalaryAdvance(null);
  };


  const editSalaryAdvanceHandleClick = (data) => {
    console.log("Edit clicked with data:", data);
    setSelectedEditSalaryAdvance(data);
    setShowEditSalaryAdvanceModal(true);
  };

  const closeEditSalaryAdvanceModal = () => {
    setShowEditSalaryAdvanceModal(false);
    setSelectedEditSalaryAdvance(null);
  };

  const updateSalaryAdvanceRequest = async (id, amount, reason) => {
    setLoadingRequest(true);
    try {
      const updateApiUrl = domain + "/api/SalaryAdvanceRequest/" + id;
      await axios.put(updateApiUrl, {
        amount: amount,
        reason: reason
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      showGeneralMessage("Request updated successfully!", true);
      await fetchSalaryAdvanceRequests();
      closeEditSalaryAdvanceModal();
    } catch (error) {
      console.error("Error updating request:", error);
      const errorMsg = error.response?.data?.message || "Failed to update request";
      showGeneralMessage(errorMsg, false);
    } finally {
      setLoadingRequest(false);
    }
  };

  const cancelSalaryAdvanceRequest = async (id) => {
    if (!window.confirm("Are you sure you want to cancel this request?")) return;

    setLoadingRequest(true);
    try {
      const cancelApiUrl = domain + "/api/SalaryAdvanceRequest/" + id + "/cancel";
      await axios.put(cancelApiUrl, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      showGeneralMessage("Request cancelled successfully!", true);
      await fetchSalaryAdvanceRequests();
    } catch (error) {
      console.error("Error cancelling request:", error);
      const errorMsg = error.response?.data?.message || "Failed to cancel request";
      showGeneralMessage(errorMsg, false);
    } finally {
      setLoadingRequest(false);
    }
  };

  function isValidDate(dateString) {
    // Attempt to create a new Date object
    const date = new Date(dateString);

    // Check if the resulting date is valid
    return !isNaN(date.getTime());
  }

  const editHandleClick = async (data) => {
    // --- REFACTORED: Use showGeneralMessage for validation feedback ---
    if (data.status === "Approved") {
      showGeneralMessage("Already approved!", false);
      return;
    } else if (data.status === "Disapproved") {
      showGeneralMessage("Already disapproved!", false);
      return;
    } else if (data.status === "Cancelled") {
      showGeneralMessage("Already cancelled!", false);
      return;
    }

    setRequestType(data.requestTypeDescription);

    if (data.requestTypeDescription === "Overtime Request") {
      setShowEditOTForm(true);
      const requestDataWithId = await fetchOTRequest(data);
      setEditData(requestDataWithId);
      setEmployeePersonalInformationFullName(
        requestDataWithId.employeePersonalInformationFullName
      );
      setEmployeePersonalInformationId(
        requestDataWithId.employeePersonalInformationId
      );
      setOvertimeType(requestDataWithId.overtimeType);
      setDate(requestDataWithId.date);
      setHours(requestDataWithId.hours);
      setHasOvertimeAllowance(requestDataWithId.hasOvertimeAllowance);
      setIsAboveTwoHoursOvertime(requestDataWithId.isAboveTwoHoursOvertime);
      setReason(requestDataWithId.reason);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesOT(filesToBeSet);
    }

    if (data.requestTypeDescription === "Leave Request") {
      setShowEditLeaveForm(true);
      const requestDataWithId = await fetchLeaveRequest(data);
      setEditData(requestDataWithId);
      setEmployeePersonalInformationFullNameLeave(
        requestDataWithId.employeePersonalInformationFullName
      );
      setLeaveType(requestDataWithId.leaveTypeId);
      setDateFromLeave(requestDataWithId.dateFrom);
      setDateToLeave(requestDataWithId.dateTo);
      setDaysLeave(requestDataWithId.days);
      setIsHalfDayLeave(requestDataWithId.isHalfDay);
      setReasonLeave(requestDataWithId.reason);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesLeave(filesToBeSet);
    }

    if (data.requestTypeDescription === "Change Schedule") {
      setShowEditChangeOfScheduleForm(true);
      const requestDataWithId = await fetchChangeOfScheduleRequest(data);
      setEditData(requestDataWithId);
      setEmployeePersonalInformationFullNameChangeSchedule(
        requestDataWithId.employeePersonalInformationFullName
      );
      setDateFromChangeSchedule(requestDataWithId.dateFrom);
      setDateToChangeSchedule(requestDataWithId.dateTo);
      setShiftScheduleFromId(requestDataWithId.shiftScheduleFromId);
      setShiftScheduleToId(requestDataWithId.shiftScheduleToId);
      setReasonChangeSchedule(requestDataWithId.reason);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesChangeSchedule(filesToBeSet);
    }

    if (data.requestTypeDescription === "Change Log Request") {
      setShowEditChangeLogForm(true);
      const requestDataWithId = await fetchChangeLogRequest(data);
      setEditData(requestDataWithId);
      setEmployeePersonalInformationIdChangeLogRequest(
        requestDataWithId.employeePersonalInformationId
      );
      setEmployeePersonalInformationFullNameChangeLogRequest(
        requestDataWithId.employeePersonalInformationFullName
      );
      setTimeTypeChangeLogRequest(requestDataWithId.timeType);
      setDateChangeLogRequest(requestDataWithId.date);
      setTimeRequestedChangeLogRequest(requestDataWithId.timeRendered);
      setReasonChangeLogRequest(requestDataWithId.reason);
      setReasonForRejectionChangeLogRequest(
        requestDataWithId.reasonForRejection
      );
      setSelectedItinerary(requestDataWithId.changeLogItineraries);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesChangeLog(filesToBeSet);
    }

    if (data.requestTypeDescription === "Offset") {
      setShowEditOffsetForm(true);
      const requestDataWithId = await fetchOffsetRequest(data);
      setEditData(requestDataWithId);
      setEmployeePersonalInformationFullNameOffset(
        requestDataWithId.employeePersonalInformationFullName
      );
      setEmployeePersonalInformationIdOffset(
        requestDataWithId.employeePersonalInformationId
      );

      setOffset_type(requestDataWithId.type);
      setOffset_type_current(requestDataWithId.type);
      setOffset_referenceDate(requestDataWithId.referenceDate);
      setOffset_date(requestDataWithId.date);
      setOffset_hours(requestDataWithId.hours);
      setOffset_referenceId(requestDataWithId.referenceId);
      setOffset_dateFrom(requestDataWithId.dateFrom);
      setOffset_dateTo(requestDataWithId.dateTo);
      setOffset_days(requestDataWithId.days);
      setOffset_reason(requestDataWithId.reason);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesOffset(filesToBeSet);
    }
  };
  const closeEditHandleClick = () => {
    if (requestType === "Overtime Request") {
      setShowEditOTForm(false);
    }

    if (requestType === "Leave Request") {
      setShowEditLeaveForm(false);
    }

    if (requestType === "Change Schedule") {
      setShowEditChangeOfScheduleForm(false);
    }

    if (requestType === "Change Log Request") {
      setShowEditChangeLogForm(false);

      setItineraryTimeIn("");
      setItineraryTimeOut("");
      setItineraryLocation("");
      setIsItinerayAddState(false);
      setIsItinerayUpdateState(false);
      setIsItinerayDeleteState(false);
    }

    if (requestType === "Offset") {
      setShowEditOffsetForm(false);

      resetOffsetVariables();
    }
  };
  const updateRequest = async (event) => {
    event.preventDefault();
    setLoadingRequest(true);

    const overTimeApiUrl = domain + "/api/OvertimeRequest";
    const leaveTimeApiUrl = domain + "/api/LeaveRequest";
    const changeOfScheduleTimeApiUrl = domain + "/api/ChangeScheduleRequest";
    const changeLogRequestTimeApiUrl = domain + "/api/ChangeLogRequest";
    const offsetRequestTimeApiUrl = domain + "/api/OffsetRequest";

    let data = {};

    var requestUrl = overTimeApiUrl;

    if (requestType === "Leave Request") {
      requestUrl = leaveTimeApiUrl;

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });

      let base64String = "";
      let photoToBeSave = "";

      if (filesLeave.length > 0) {
        base64String = await toBase64(filesLeave[0]);
        photoToBeSave = base64String.split(",")[1];
      }

      const uploadImage = filesLeave ? photoToBeSave : null;

      data = {
        referenceNumber: editData.referenceNumber,
        employeePersonalInformationId: filteredEmployee.id, //temporary
        approverId: editData.approverId,
        requestTypeId: editData.requestTypeId,
        reason: reasonLeave,
        reasonForRejection: editData.reasonForRejection,
        status: editData.status,
        dateRequested: editData.dateRequested,
        dateCompleted: editData.dateCompleted,
        content: uploadImage,
        dateFrom: dateFromLeave,
        dateTo: dateToLeave,
        leaveTypeId: leaveType,
        days: daysLeave,
        isHalfDay: isHalfDayLeave,
      };
    }

    if (requestType === "Change Schedule") {
      requestUrl = changeOfScheduleTimeApiUrl;

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });

      let base64String = "";
      let photoToBeSave = "";

      if (filesChangeSchedule.length > 0) {
        base64String = await toBase64(filesChangeSchedule[0]);
        photoToBeSave = base64String.split(",")[1];
      }

      const uploadImage = filesChangeSchedule ? photoToBeSave : null;

      data = {
        referenceNumber: editData.referenceNumber,
        employeePersonalInformationId: filteredEmployee.id, //temporary
        approverId: editData.approverId,
        requestTypeId: editData.requestTypeId,
        reason: reasonChangeSchedule,
        reasonForRejection: editData.reasonForRejection,
        status: editData.status,
        dateRequested: editData.dateRequested,
        dateCompleted: editData.dateCompleted,
        content: uploadImage,
        dateFrom: dateFromChangeSchedule,
        dateTo: dateToChangeSchedule,
        shiftScheduleFromId: shiftScheduleFromId,
        shiftScheduleToId: shiftScheduleToId,
      };
    }

    if (requestType === "Overtime Request") {
      requestUrl = overTimeApiUrl;

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });

      let base64String = "";
      let photoToBeSave = "";

      if (filesOT.length > 0) {
        base64String = await toBase64(filesOT[0]);
        photoToBeSave = base64String.split(",")[1];
      }

      const uploadImage = filesOT ? photoToBeSave : null;

      data = {
        referenceNumber: editData.referenceNumber,
        employeePersonalInformationId: filteredEmployee.id, //temporary
        approverId: editData.approverId,
        requestTypeId: editData.requestTypeId,
        reason: reason,
        reasonForRejection: editData.reasonForRejection,
        status: editData.status,
        dateRequested: editData.dateRequested,
        dateCompleted: editData.dateCompleted,
        content: uploadImage,
        date: date,
        hours: hours,
        overtimeType: overtimeType,
        hasOvertimeAllowance: hasOvertimeAllowance,
        isAboveTwoHoursOvertime: isAboveTwoHoursOvertime,
      };
    }

    if (requestType === "Change Log Request") {
      requestUrl = changeLogRequestTimeApiUrl;

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });

      let base64String = "";
      let photoToBeSave = "";

      if (filesChangeLog.length > 0) {
        base64String = await toBase64(filesChangeLog[0]);
        photoToBeSave = base64String.split(",")[1];
      }

      const uploadImage = filesChangeLog ? photoToBeSave : null;

      const _changeLogItineraries = selectedItinerary.map((item) => {
        let _timeIn = item.timeIn;
        let _timeOut = item.timeOut;
        const dateLog = dateChangeLogRequest.split("T")[0];

        if (isValidDate(_timeIn)) {
          _timeIn = item.timeIn && item.timeIn.split("T")[1];
        }

        if (isValidDate(_timeOut)) {
          _timeOut = item.timeOut && item.timeOut.split("T")[1];
        }

        _timeIn = `${dateLog}T${_timeIn}`;
        _timeOut = `${dateLog}T${_timeOut}`;

        return {
          changeLogRequestId: item.changeLogRequestId,
          timeIn: _timeIn, // Replace this with actual date/time if available
          timeOut: _timeOut, // Replace this with actual date/time if available
          location: item.location,
        };
      });

      data = {
        referenceNumber: editData.referenceNumber,
        employeePersonalInformationId: filteredEmployee.id, //temporary
        approverId: editData.approverId,
        requestTypeId: editData.requestTypeId,
        reason: reasonChangeLogRequest,
        reasonForRejection: editData.reasonForRejection,
        status: editData.status,
        dateRequested: editData.dateRequested,
        dateCompleted: editData.dateCompleted,
        content: uploadImage,
        date: dateChangeLogRequest,
        timeRendered: timeRequestedChangeLogRequest,
        timeType: timeTypeChangeLogRequest,
        changeLogItineraries: _changeLogItineraries,
      };
    }

    if (requestType === "Offset") {
      requestUrl = offsetRequestTimeApiUrl;

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });

      let base64String = "";
      let photoToBeSave = "";

      if (filesOffset.length > 0) {
        base64String = await toBase64(filesOffset[0]);
        photoToBeSave = base64String.split(",")[1];
      }

      const uploadImage = filesOffset ? photoToBeSave : null;

      data = {
        referenceNumber: editData.referenceNumber,
        employeePersonalInformationId: filteredEmployee.id, //temporary
        approverId: editData.approverId,
        requestTypeId: editData.requestTypeId,
        reason: offset_reason,
        reasonForRejection: editData.reasonForRejection,
        status: editData.status,
        dateRequested: editData.dateRequested,
        dateCompleted: editData.dateCompleted,
        content: uploadImage,
        referenceDate: offset_referenceDate ? offset_referenceDate : null,
        date: offset_date ? offset_date : null,
        hours: offset_hours ? offset_hours : 0,
        type: offset_type,
        referenceId: offset_referenceId ? offset_referenceId : null,
        dateFrom: offset_dateFrom ? offset_dateFrom : null,
        dateTo: offset_dateTo ? offset_dateTo : null,
        days: offset_days ? offset_days : null,
      };
    }

    try {
      await axios.put(requestUrl + `/${editData.id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("Data updated successfully");

      closeEditHandleClick();

      // Reload table data and reset form fields
      await fetchData(); // Assuming fetchData() fetches the updated data for the table
      await fetchOTRequestData();
      await fetchLeaveRequestData();
      await fetchChangeOfScheduleRequestData();
      await fetchChangeLogRequestData();
      setEditData([]);

      // --- REFACTORED: Success Message ---
      showGeneralMessage("Request Success!", true);
    } catch (error) {
      console.error("There was a problem updating data:", error);
      setLoadingRequest(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;

      // --- REFACTORED: Error Message ---
      showGeneralMessage(errorMessage, false);
    } finally {
      setLoadingRequest(false);
    }
  };

  const deleteHandleClick = (data) => {
    /* if(data.status === "Approved"){
            setApproveMessage(true);
            return;
        } else if(data.status === "Disapproved"){
            setDisapproveMessage(true);
            return;
        } else */ 
    if (data.status === "Cancelled") {
      // --- REFACTORED: Use showGeneralMessage for validation feedback ---
      showGeneralMessage("Already cancelled!", false);
      return;
    }

    setRequestType(data.requestTypeDescription);
    setDeleteData(data);
    setShowDeleteForm(true);
  };
  const closeDeleteHandleClick = () => {
    setShowDeleteForm(false);
  };
  const cancelRequest = async (event) => {
    event.preventDefault();
    setLoadingRequest(true);

    const overTimeApiUrl = domain + "/api/OvertimeRequest";
    const leaveTimeApiUrl = domain + "/api/LeaveRequest";
    const changeOfScheduleTimeApiUrl = domain + "/api/ChangeScheduleRequest";
    const changeLogRequestTimeApiUrl = domain + "/api/ChangeLogRequest";
    const offsetRequestTimeApiUrl = domain + "/api/OffsetRequest";

    var requestUrl = overTimeApiUrl;

    if (requestType === "Leave Request") {
      requestUrl = leaveTimeApiUrl;
    }

    if (requestType === "Change Schedule") {
      requestUrl = changeOfScheduleTimeApiUrl;
    }

    if (requestType === "Overtime Request") {
      requestUrl = overTimeApiUrl;
    }

    if (requestType === "Change Log Request") {
      requestUrl = changeLogRequestTimeApiUrl;
    }

    if (requestType === "Offset") {
      requestUrl = offsetRequestTimeApiUrl;
    }

    const data = {
      id: deleteData.id,
      approverId: user.employeePersonalInformationId, //temporary, change this into correct approver. This is just to identify the user who cancelled the request for now
      status: "Cancelled",
      reasonForRejection: "",
    };

    try {
      await axios.put(requestUrl + "/status", data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("Data updated successfully");

      setShowDeleteForm(false);

      // Reload table data and reset form fields
      await fetchData(); // Assuming fetchData() fetches the updated data for the table
      await fetchOTRequestData();
      await fetchLeaveRequestData();
      await fetchChangeOfScheduleRequestData();
      await fetchChangeLogRequestData();
      setDeleteData([]);

      // --- REFACTORED: Success Message ---
      showGeneralMessage("Request Success!", true);
    } catch (error) {
      console.error("There was a problem updating data:", error);
      setLoadingRequest(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;

      // --- REFACTORED: Error Message ---
      showGeneralMessage(errorMessage, false);
    } finally {
      setLoadingRequest(false);
    }
  };

  const viewImage = (data) => {
    setViewImageData(data);
    setShowViewImage(true);
  };
  const closeViewImage = () => {
    setShowViewImage(false);
  };

  return (
    <div>
      {/* Tabs */}
      <div className="tabs-container" style={{ display: "flex", borderBottom: "1px solid #ddd", marginBottom: "20px" }}>
        <button
          className={`tab-button ${activeTab === "workflow" ? "active" : ""}`}
          onClick={() => setActiveTab("workflow")}
          style={{
            padding: "10px 20px",
            background: activeTab === "workflow" ? "#3b82f6" : "transparent",
            color: activeTab === "workflow" ? "white" : "#333",
            border: "none",
            cursor: "pointer",
            borderRadius: "8px 8px 0 0",
            fontWeight: "bold",
          }}
        >
          Workflow Requests
        </button>
        <button
          className={`tab-button ${activeTab === "financial" ? "active" : ""}`}
          onClick={() => setActiveTab("financial")}
          style={{
            padding: "10px 20px",
            background: activeTab === "financial" ? "#3b82f6" : "transparent",
            color: activeTab === "financial" ? "white" : "#333",
            border: "none",
            cursor: "pointer",
            borderRadius: "8px 8px 0 0",
            fontWeight: "bold",
          }}
        >
          Financial Requests (Salary Advance)
        </button>
      </div>

      {/* Workflow Requests Tab */}
      {activeTab === "workflow" && (
        <>
          <div className="Header">
            <div className="titleContainer">
              <div className="row" style={{ margin: "5px 0" }}>
                <span>{`Primary Approver/s: `}</span>
                {generatePrimaryApprover()}
              </div>
              <div className="row" style={{ margin: "5px 0" }}>
                <span>{`Secondary Approver/s: `}</span>
                {generateSecondaryApprover()}
              </div>
              <div className="row" style={{ margin: "5px 0" }}>
                <span>{`Tertiary Approver/s: `}</span>
                {generateTertiaryApprover()}
              </div>
            </div>
            <div
              className="filter-item-payroll popUp-item info-item row"
              style={{ alignItems: "center", marginLeft: "25px" }}
            >
              <div className="info-item-label">Days Range: </div>
              <div className="info-item-input" style={{ marginLeft: "5px" }}>
                <input
                  id="employeePersonalInformationFullName"
                  placeholder="Days Range"
                  value={daysRangeTemp}
                  onChange={(e) => setDaysRangeTemp(e.target.value)}
                  type="number"
                />
              </div>
              <div style={{ marginLeft: "5px" }}>
                <Button
                  name={"UPDATE"}
                  icon={<UpdateIcon fontSize="small" />}
                  onClick={updateDaysRange}
                  className={"bg-blue-500 hover:bg-blue-600 text-white"}
                />
              </div>
            </div>
          </div>

          <div id="container1" className="InfoList container">
            <CreateTableTransaction
              dataList={transactions}
              dataHeader={header}
              dataAccessor={accessor}
              viewHandleClick={viewHandleClick}
              editHandleClick={editHandleClick}
              deleteHandleClick={deleteHandleClick}
              viewImage={viewImage}
              overtimeRequestData={overtimeRequestData}
              leaveRequestData={leaveRequestData}
              changeOfScheduleData={changeOfScheduleData}
              changeLogRequestData={changeLogRequestData}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setOvertimeRequestData={setOvertimeRequestData}
              setLeaveRequestData={setLeaveRequestData}
              setChangeOfScheduleData={setChangeOfScheduleData}
              setChangeLogRequestData={setChangeLogRequestData}
            />
          </div>
        </>
      )}

      {/* Financial Requests Tab */}
      {activeTab === "financial" && (
        <div className="financial-requests-container">
          <div className="Header">
            <div className="titleContainer">
              <div className="row" style={{ margin: "5px 0" }}>
                <span>Salary Advance Requests</span>
              </div>
            </div>
            <div
              className="filter-item-payroll popUp-item info-item row"
              style={{ alignItems: "center", marginLeft: "25px" }}
            >
              <div className="info-item-label">Days Range: </div>
              <div className="info-item-input" style={{ marginLeft: "5px" }}>
                <input
                  placeholder="Days Range"
                  value={daysRangeTemp}
                  onChange={(e) => setDaysRangeTemp(e.target.value)}
                  type="number"
                />
              </div>
              <div style={{ marginLeft: "5px" }}>
                <Button
                  name={"UPDATE"}
                  icon={<UpdateIcon fontSize="small" />}
                  onClick={updateDaysRange}
                  className={"bg-blue-500 hover:bg-blue-600 text-white"}
                />
              </div>
            </div>
          </div>

          <div id="container1" className="InfoList container">
            <CreateTableNew
              tableName="SalaryAdvance"
              headers={[
                "Reference No.",
                "Date From",
                "Date To",
                "Request Date",
                "Request",
                "Approvers",
                "Status",
                "Actions"
              ]}
              accessors={[
                "formattedReferenceNumber",
                "dateFrom",
                "dateTo",
                "requestDate",
                "requestTypeDescription",
                "approverHierarchy",
                "status",
                "actions"
              ]}
              data={salaryAdvanceRequests.map((request) => ({
                id: request.id,
                referenceNumber: request.referenceNumber,
                formattedReferenceNumber: request.formattedReferenceNumber,
                requestTypeDescription: request.requestTypeDescription,
                status: request.status,
                dateFrom: request.dateFrom,
                dateTo: request.dateTo,
                requestDate: request.requestDate,
                currentHierarchy: request.currentHierarchy,
                hierarchyCount: request.hierarchyCount,
                amount: request.amount,
                reason: request.reason,
                approvals: request.approvals,
                approverHierarchy: `${request.hierarchyCount} ${request.hierarchyCount === 1 ? 'Approver' : 'Approvers'}`,  // Shows "2 Approvers"
                canEdit: request.canEdit,
                canCancel: request.canCancel,
                _rawData: { ...request },
              }))}

              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              itemsPerPage={7}
              totalItems={salaryAdvanceRequests.length}
              actions={[
                {
                  name: "Edit",
                  icon: <EditIcon fontSize="small" />,
                  color: "bg-green-500 hover:bg-green-600",
                  tooltip: "Edit Request",
                  className: "p-1",
                  visible: (row) => row.canEdit === true,
                  function: (row) => editSalaryAdvanceHandleClick(row)
                },
                {
                  name: "Cancel",
                  icon: <NotInterestedIcon fontSize="small" />,
                  color: "bg-red-500 hover:bg-red-600",
                  tooltip: "Cancel Request",
                  className: "p-1",
                  visible: (row) => row.canCancel === true,
                  function: (row) => cancelSalaryAdvanceRequest(row.id),
                  visible: (row) => row?.status === SALARYADVANCETATUS.PENDING,
                },
                {
                  name: "View",
                  icon: <RemoveRedEyeIcon fontSize="small" />,
                  color: "bg-blue-500 hover:bg-blue-600",
                  tooltip: "View Details",
                  className: "p-1",
                  visible: () => true,
                  function: (row) => viewSalaryAdvanceHandleClick(row)
                }
              ]}
              customCellRenderer={(row, accessor) => {
                // Format date fields
                if (accessor === "dateFrom" && row.dateFrom) {
                  const date = new Date(row.dateFrom);
                  if (!isNaN(date.getTime())) {
                    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
                  }
                }

                if (accessor === "dateTo") {
                  if (!row.dateTo) return "—";
                  const date = new Date(row.dateTo);
                  if (!isNaN(date.getTime())) {
                    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
                  }
                  return "—";
                }

                if (accessor === "requestDate" && row.requestDate) {
                  const date = new Date(row.requestDate);
                  if (!isNaN(date.getTime())) {
                    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
                  }
                }

                if (accessor === "formattedReferenceNumber") {
                  if (row.formattedReferenceNumber && row.formattedReferenceNumber !== row.referenceNumber) {
                    return row.formattedReferenceNumber;
                  }
                  if (row.referenceNumber) {
                    const num = row.referenceNumber.toString().replace("SAR-", "");
                    const padded = num.padStart(6, "0");
                    return `SAR-${padded}`;
                  }
                  return "N/A";
                }

                if (accessor === "status") {
                  // Use your existing StatusBadge component
                  return <StatusBadge status={row.status} />;
                }

                // Return null to use default rendering
                return null;
              }}
              emptyMessage="No salary advance requests found."
            />
          </div>
        </div>
      )}

      <ViewOTForm
        isOpen={showViewOTForm}
        onClose={closeViewHandleClick}
        employeePersonalInformationFullName={
          employeePersonalInformationFullName
        }
        employeePersonalInformationId={employeePersonalInformationId}
        overtimeType={overtimeType}
        date={date}
        hours={hours}
        hasOvertimeAllowance={hasOvertimeAllowance}
        isAboveTwoHoursOvertime={isAboveTwoHoursOvertime}
        reason={reason}
        setEmployeePersonalInformationFullName={
          setEmployeePersonalInformationFullName
        }
        setEmployeePersonalInformationId={setEmployeePersonalInformationId}
        setOvertimeType={setOvertimeType}
        setDate={setDate}
        files={filesOT}
        setFiles={setFilesOT}
        viewImage={viewImage}
      ></ViewOTForm>
      <ViewLeaveForm
        isOpen={showViewLeaveForm}
        onClose={closeViewHandleClick}
        employeePersonalInformationFullNameLeave={
          employeePersonalInformationFullNameLeave
        }
        leaveType={leaveType}
        dateFromLeave={dateFromLeave}
        dateToLeave={dateToLeave}
        daysLeave={daysLeave}
        isHalfDayLeave={isHalfDayLeave}
        reasonLeave={reasonLeave}
        setEmployeePersonalInformationFullNameLeave={
          setEmployeePersonalInformationFullNameLeave
        }
        setLeaveType={setLeaveType}
        setDateFromLeave={setDateFromLeave}
        setDateToLeave={setDateToLeave}
        files={filesLeave}
        setFiles={setFilesLeave}
        viewImage={viewImage}
      ></ViewLeaveForm>
      <ViewChangeScheduleForm
        isOpen={showViewChangeScheduleForm}
        onClose={closeViewHandleClick}
        employeePersonalInformationFullNameChangeSchedule={
          employeePersonalInformationFullNameChangeSchedule
        }
        dateFromChangeSchedule={dateFromChangeSchedule}
        dateToChangeSchedule={dateToChangeSchedule}
        shiftScheduleFromId={shiftScheduleFromId}
        shiftScheduleToId={shiftScheduleToId}
        reasonChangeSchedule={reasonChangeSchedule}
        setEmployeePersonalInformationFullNameChangeSchedule={
          setEmployeePersonalInformationFullNameChangeSchedule
        }
        setDateFromChangeSchedule={setDateFromChangeSchedule}
        setDateToChangeSchedule={setDateToChangeSchedule}
        setShiftScheduleFromId={setShiftScheduleFromId}
        setShiftScheduleToId={setShiftScheduleToId}
        files={filesChangeSchedule}
        setFiles={setFilesChangeSchedule}
        viewImage={viewImage}
      ></ViewChangeScheduleForm>
      <ViewChangeLogRequestForm
        isOpen={showViewChangeLogRequestForm}
        onClose={closeViewHandleClick}
        employeePersonalInformationIdChangeLogRequest={
          employeePersonalInformationIdChangeLogRequest
        }
        employeePersonalInformationFullNameChangeLogRequest={
          employeePersonalInformationFullNameChangeLogRequest
        }
        timeTypeChangeLogRequest={timeTypeChangeLogRequest}
        dateChangeLogRequest={dateChangeLogRequest}
        timeRequestedChangeLogRequest={timeRequestedChangeLogRequest}
        statusChangeLogRequest={statusChangeLogRequest}
        reasonChangeLogRequest={reasonChangeLogRequest}
        reasonForRejectionChangeLogRequest={reasonForRejectionChangeLogRequest}
        setEmployeePersonalInformationIdChangeLogRequest={
          setEmployeePersonalInformationIdChangeLogRequest
        }
        setEmployeePersonalInformationFullNameChangeLogRequest={
          setEmployeePersonalInformationFullNameChangeLogRequest
        }
        setTimeTypeChangeLogRequest={setTimeTypeChangeLogRequest}
        setDateChangeLogRequest={setDateChangeLogRequest}
        setTimeRequestedChangeLogRequest={setTimeRequestedChangeLogRequest}
        setStatusChangeLogRequest={setStatusChangeLogRequest}
        setReasonChangeLogRequest={setReasonChangeLogRequest}
        setReasonForRejectionChangeLogRequest={
          setReasonForRejectionChangeLogRequest
        }
        files={filesChangeLog}
        setFiles={setFilesChangeLog}
        data={selectedItinerary}
        viewImage={viewImage}
      ></ViewChangeLogRequestForm>
      <ViewOffsetForm
        isOpen={showViewOffsetForm}
        onClose={closeViewHandleClick}
        employeePersonalInformationFullName={employeePersonalInformationFullNameOffset} setEmployeePersonalInformationFullName={setEmployeePersonalInformationFullNameOffset}
        employeePersonalInformationId={employeePersonalInformationIdOffset} setEmployeePersonalInformationId={setEmployeePersonalInformationIdOffset}
        referenceDate={offset_referenceDate} setReferenceDate={setOffset_referenceDate}
        date={offset_date} setDate={setOffset_date}
        hours={offset_hours} setHours={setOffset_hours}
        type={offset_type} setType={setOffset_type}
        referenceId={offset_referenceId} setReferenceId={setOffset_referenceId}
        dateFrom={offset_dateFrom} setDateFrom={setOffset_dateFrom}
        dateTo={offset_dateTo} setDateTo={setOffset_dateTo}
        days={offset_days} setDays={setOffset_days}
        reason={offset_reason} setReason={setOffset_reason}
        files={filesOffset} setFiles={setFilesOffset}
        viewImage={viewImage}
      ></ViewOffsetForm>
      <EditOTForm
        isOpen={showEditOTForm}
        onClose={closeEditHandleClick}
        employeePersonalInformationFullName={
          employeePersonalInformationFullName
        }
        employeePersonalInformationId={employeePersonalInformationId}
        overtimeType={overtimeType}
        date={date}
        hours={hours}
        hasOvertimeAllowance={hasOvertimeAllowance}
        isAboveTwoHoursOvertime={isAboveTwoHoursOvertime}
        reason={reason}
        setEmployeePersonalInformationFullName={
          setEmployeePersonalInformationFullName
        }
        setEmployeePersonalInformationId={setEmployeePersonalInformationId}
        setOvertimeType={setOvertimeType}
        setHasOvertimeAllowance={setHasOvertimeAllowance}
        setIsAboveTwoHoursOvertime={setIsAboveTwoHoursOvertime}
        setHours={setHours}
        setReason={setReason}
        setDate={setDate}
        handleUpdate={updateRequest}
        files={filesOT}
        setFiles={setFilesOT}
        viewImage={viewImage}
      ></EditOTForm>
      <EditLeaveForm
        isOpen={showEditLeaveForm}
        onClose={closeEditHandleClick}
        employeePersonalInformationFullNameLeave={
          employeePersonalInformationFullNameLeave
        }
        leaveType={leaveType}
        dateFromLeave={dateFromLeave}
        dateToLeave={dateToLeave}
        daysLeave={daysLeave}
        isHalfDayLeave={isHalfDayLeave}
        reasonLeave={reasonLeave}
        setEmployeePersonalInformationFullNameLeave={
          setEmployeePersonalInformationFullNameLeave
        }
        setLeaveType={setLeaveType}
        setDateFromLeave={setDateFromLeave}
        setDateToLeave={setDateToLeave}
        setDaysLeave={setDaysLeave}
        setIsHalfDayLeave={setIsHalfDayLeave}
        setReasonLeave={setReasonLeave}
        handleUpdate={updateRequest}
        files={filesLeave}
        setFiles={setFilesLeave}
        viewImage={viewImage}
      ></EditLeaveForm>
      <EditChangeScheduleForm
        isOpen={showEditChangeOfScheduleForm}
        onClose={closeEditHandleClick}
        employeePersonalInformationFullNameChangeSchedule={
          employeePersonalInformationFullNameChangeSchedule
        }
        dateFromChangeSchedule={dateFromChangeSchedule}
        dateToChangeSchedule={dateToChangeSchedule}
        shiftScheduleFromId={shiftScheduleFromId}
        shiftScheduleToId={shiftScheduleToId}
        reasonChangeSchedule={reasonChangeSchedule}
        setEmployeePersonalInformationFullNameChangeSchedule={
          setEmployeePersonalInformationFullNameChangeSchedule
        }
        setDateFromChangeSchedule={setDateFromChangeSchedule}
        setDateToChangeSchedule={setDateToChangeSchedule}
        setShiftScheduleFromId={setShiftScheduleFromId}
        setShiftScheduleToId={setShiftScheduleToId}
        setReasonChangeSchedule={setReasonChangeSchedule}
        handleUpdate={updateRequest}
        files={filesChangeSchedule}
        setFiles={setFilesChangeSchedule}
        viewImage={viewImage}
      ></EditChangeScheduleForm>
      <EditChangeLogRequestForm
        isOpen={showEditChangeLogForm}
        onClose={closeEditHandleClick}
        employeePersonalInformationIdChangeLogRequest={
          employeePersonalInformationIdChangeLogRequest
        }
        employeePersonalInformationFullNameChangeLogRequest={
          employeePersonalInformationFullNameChangeLogRequest
        }
        timeTypeChangeLogRequest={timeTypeChangeLogRequest}
        dateChangeLogRequest={dateChangeLogRequest}
        timeRequestedChangeLogRequest={timeRequestedChangeLogRequest}
        statusChangeLogRequest={statusChangeLogRequest}
        reasonChangeLogRequest={reasonChangeLogRequest}
        reasonForRejectionChangeLogRequest={reasonForRejectionChangeLogRequest}
        setEmployeePersonalInformationIdChangeLogRequest={
          setEmployeePersonalInformationIdChangeLogRequest
        }
        setEmployeePersonalInformationFullNameChangeLogRequest={
          setEmployeePersonalInformationFullNameChangeLogRequest
        }
        setTimeTypeChangeLogRequest={setTimeTypeChangeLogRequest}
        setDateChangeLogRequest={setDateChangeLogRequest}
        setTimeRequestedChangeLogRequest={setTimeRequestedChangeLogRequest}
        setStatusChangeLogRequest={setStatusChangeLogRequest}
        setReasonChangeLogRequest={setReasonChangeLogRequest}
        setReasonForRejectionChangeLogRequest={
          setReasonForRejectionChangeLogRequest
        }
        handleUpdate={updateRequest}
        files={filesChangeLog}
        setFiles={setFilesChangeLog}
        data={selectedItinerary}
        setData={setSelectedItinerary}
        itineraryTimeIn={itineraryTimeIn}
        setItineraryTimeIn={setItineraryTimeIn}
        itineraryTimeOut={itineraryTimeOut}
        setItineraryTimeOut={setItineraryTimeOut}
        itineraryLocation={itineraryLocation}
        setItineraryLocation={setItineraryLocation}
        isItinerayAddState={isItinerayAddState}
        setIsItinerayAddState={setIsItinerayAddState}
        isItinerayUpdateState={isItinerayUpdateState}
        setIsItinerayUpdateState={setIsItinerayUpdateState}
        isItinerayDeleteState={isItinerayDeleteState}
        setIsItinerayDeleteState={setIsItinerayDeleteState}
        viewImage={viewImage}
      ></EditChangeLogRequestForm>
      <EditOffsetForm
        user={user}
        isOpen={showEditOffsetForm}
        onClose={closeEditHandleClick}
        employeePersonalInformationFullName={employeePersonalInformationFullNameOffset} setEmployeePersonalInformationFullName={setEmployeePersonalInformationFullNameOffset}
        employeePersonalInformationId={employeePersonalInformationIdOffset} setEmployeePersonalInformationId={setEmployeePersonalInformationIdOffset}
        referenceDate={offset_referenceDate} setReferenceDate={setOffset_referenceDate}
        date={offset_date} setDate={setOffset_date}
        hours={offset_hours} setHours={setOffset_hours}
        type={offset_type} setType={setOffset_type}
        referenceId={offset_referenceId} setReferenceId={setOffset_referenceId}
        dateFrom={offset_dateFrom} setDateFrom={setOffset_dateFrom}
        dateTo={offset_dateTo} setDateTo={setOffset_dateTo}
        days={offset_days} setDays={setOffset_days}
        reason={offset_reason} setReason={setOffset_reason}
        files={filesOffset} setFiles={setFilesOffset}
        handleUpdate={updateRequest}
        viewImage={viewImage}
      ></EditOffsetForm>

      <ClearGeneralForm
        isOpen={showDeleteForm}
        onClose={closeDeleteHandleClick}
        handleDelete={cancelRequest}
      />
      <ViewImage
        isOpen={showViewImage}
        onClose={closeViewImage}
        viewImageData={viewImageData}
      ></ViewImage>

      <ViewSalaryAdvanceModal
        isOpen={showSalaryAdvanceModal}
        onClose={closeSalaryAdvanceModal}
        requestData={selectedSalaryAdvance}
      />

      <EditSalaryAdvanceModal
        isOpen={showEditSalaryAdvanceModal}
        onClose={closeEditSalaryAdvanceModal}
        requestData={selectedEditSalaryAdvance}
        onUpdate={updateSalaryAdvanceRequest}
      />

      {/* --- REFACTORED: Replaced GenerateMessage components with single GeneralMessage --- */}
      <GeneralMessage
        form={showMessage}
        message={apiMessage}
        isSuccess={apiIsSuccess}
        duration={5000}
      />

      <LoadingSpinner loading={loadingRequest || loading || loadingSalaryAdvance} />
    </div>
  );
};